/**
 * 供应商商品
 */
export const GYL_KEY = 'GYL'
/**
 * 供应商ERP商品
 */
export const ERP_SUPPLIER_KEY = 'ERP_SUPPLIER'
/**
 * ERP直接铺货
 */
export const ERP_DIRECT = 'ERP_DIRECT'
/**
 * 组合装商品铺货
 */
export const COMBINE_KEY = 'COMBINE'
/**
 * 店铺商品
 */
export const ONLINE_ITEM = 'ONLINE_ITEM'
/**
 * 店铺商品编辑更新
 */
export const ONLINE_EDIT = 'ONLINE_EDIT'
/**
 * 供应链日志
 */
export const GYL_LOG = 'LOG'
